import React, {Component} from "react";
import PropTypes from "prop-types";
import Form from 'react-bootstrap/Form';
import ConnectsTo from "../ConnectsTo";
import {Button, InputGroup} from "react-bootstrap";
import {FaRegTrashAlt} from "react-icons/fa";

class WaveShaper extends Component {
  static propTypes = {
    config: PropTypes.object,
    connectables: PropTypes.array,
    deleteTool: PropTypes.func,
    setToolConfig: PropTypes.func
  }

  constructor(props) {
    super(props);
    this.state = {};

    this.setCurve = this.setCurve.bind(this);
  }

  setCurve = (event) => {
    this.props.config.curve = event.target.value;
    this.props.setToolConfig(this.props.config.id, this.props.config);
  }

  render() {
    return (
        <div className={"waveshaper toolChainTool"}>
          <h3>WaveShaper</h3>
          <Button variant={"danger"} onClick={() => {this.props.deleteTool(this.props.config.id)}}><FaRegTrashAlt /></Button>
          <InputGroup>
            <InputGroup.Text>id</InputGroup.Text>
            <Form.Control type="text" value={this.props.config.id}
                          onChange={this.setToolId}/>
          </InputGroup>
          <Form.Group>
            <Form.Label>Curve</Form.Label>
            <Form.Control
                type="text"
                value={this.props.config.curve}
                onChange={this.setCurve}
            />
          </Form.Group>
          <InputGroup>
            <InputGroup.Text>Oversample</InputGroup.Text>
            <Form.Select value={this.props.config.oversample}>
              <option value="none">none</option>
              <option value="2x">2x</option>
              <option value="4x">4x</option>
            </Form.Select>
          </InputGroup>
          <ConnectsTo
              connectables={this.props.connectables}
              config={this.props.config}
              setToolConfig={this.props.setToolConfig}/>
        </div>
    );
  }
}

export default WaveShaper;